import styled from 'styled-components';
import { Container } from '@landr/maestro';
import contentStyles from './themes/Content.default';
import { StyledContentProps } from './Content.types';

export const Content = styled(Container)<StyledContentProps>`
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    ${({ contentPosition }) => contentStyles.position[contentPosition]};

    white-space: normal;
`;
